import React from 'react';
import { useMutation } from '@apollo/client';
import ShoppingCartProductSaveMutation from './ShoppingCartProductSaveMutation';

interface ISavePaymentProductsConnectorApollo {
  children: ({
    savePaymentProduct,
  }: {
    savePaymentProduct: (
      productId: number,
      promoCode?: string,
      source?: string
    ) => Promise<unknown>;
  }) => React.ReactElement;
}

const SavePaymentProductsConnectorApollo: React.FC<ISavePaymentProductsConnectorApollo> = ({
  children,
}) => {
  const [savePaymentProducts] = useMutation(ShoppingCartProductSaveMutation);

  const createSavePaymentProduct = async (
    productId: number,
    promoCode?: string,
    source?: string
  ) => {
    const response = await savePaymentProducts({
      variables: {
        products: [{ id: productId, amount: 1, lastSource: source }],
        promoCode: promoCode,
        firstSource: source,
      },
    });

    return response;
  };

  return children({ savePaymentProduct: createSavePaymentProduct });
};

export default SavePaymentProductsConnectorApollo;
